import { trans } from './lang';

// eslint-disable-next-line import/prefer-default-export
export const lang = trans;
